'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reduxConnect = require('redux-connect');

var _reactI18next = require('react-i18next');

var _myPlaylists = require('redux/modules/my-playlists');

var myPlaylistsActions = _interopRequireWildcard(_myPlaylists);

var _playlists = require('redux/modules/playlists');

var playlistsActions = _interopRequireWildcard(_playlists);

var _asyncPromise = require('helpers/async-promise');

var _asyncPromise2 = _interopRequireDefault(_asyncPromise);

var _MyPlaylistsList = require('containers/MyPlaylists/components/MyPlaylistsList');

var _MyPlaylistsList2 = _interopRequireDefault(_MyPlaylistsList);

var _myPlaylists2 = require('selectors/my-playlists');

var _AddPlaylistButton = require('containers/MyPlaylists/components/AddPlaylistButton');

var _AddPlaylistButton2 = _interopRequireDefault(_AddPlaylistButton);

var _Page = require('components/Page/Page');

var _Page2 = _interopRequireDefault(_Page);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./MyPlaylists.scss');

var MyPlaylists = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;
    return (0, _asyncPromise2.default)(dispatch(myPlaylistsActions.loadMyPlaylists()));
  }
}, {
  promise: function promise(_ref2) {
    var dispatch = _ref2.store.dispatch;

    if (!dispatch(playlistsActions.isLoaded())) {
      return (0, _asyncPromise2.default)(dispatch(playlistsActions.loadPlaylists()).promise);
    }
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    myPlaylists: (0, _myPlaylists2.getMyPlaylists)(state),
    myPlaylistsLoading: state.myPlaylists.myPlaylistsLoading
  };
}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(MyPlaylists, _Component);

  function MyPlaylists() {
    (0, _classCallCheck3.default)(this, MyPlaylists);
    return (0, _possibleConstructorReturn3.default)(this, (MyPlaylists.__proto__ || (0, _getPrototypeOf2.default)(MyPlaylists)).apply(this, arguments));
  }

  (0, _createClass3.default)(MyPlaylists, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          myPlaylists = _props.myPlaylists,
          myPlaylistsLoading = _props.myPlaylistsLoading;

      var title = t('My Playlists');

      return _react2.default.createElement(
        _Page2.default,
        { title: title, header: title },
        _react2.default.createElement(
          'div',
          { className: styles.headLine },
          _react2.default.createElement(
            'h3',
            { className: 'margin-free' },
            t('Playlists')
          ),
          _react2.default.createElement(_AddPlaylistButton2.default, null)
        ),
        _react2.default.createElement(_MyPlaylistsList2.default, { playlists: myPlaylists, loading: myPlaylistsLoading })
      );
    }
  }]);
  return MyPlaylists;
}(_react.Component), _class2.propTypes = {
  myPlaylists: _propTypes2.default.array,
  myPlaylistsLoading: _propTypes2.default.bool,
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  myPlaylists: []
}, _temp)) || _class) || _class) || _class);
exports.default = MyPlaylists;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyPlaylists/MyPlaylists.js
// module id = 2170
// module chunks = 1